import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import AdminNavBar from "../../../components/navegation/AdminNavBar";
import ValidateLicenseSection from "./ValidateLicenseSection";
import AdminLogsSection from "./AdminLogsSection";
import RegisteredCPAsSection from "./RegisteredCPAsSection";
import AffiliateApplicationsSection from "./AffiliateApplicationsSection";
import UnacceptedFilingsSection from "./UnacceptedFilingsSection";

const CustomAdminDashboard = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("validate-license");

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab === "logs") {
      setActiveTab("logs");
    } else if (tab === "registered-cpas") {
      setActiveTab("registered-cpas");
    } else if (tab === "affiliate-applications") {
      setActiveTab("affiliate-applications");
    } else if (tab === "unaccepted-filings") {
      setActiveTab("unaccepted-filings");
    } else {
      setActiveTab("validate-license");
    }
  }, [searchParams]);

  const getPageTitle = () => {
    if (activeTab === "logs") return "Custom Admin / Admin Logs";
    if (activeTab === "registered-cpas")
      return "Custom Admin / Registered CPAs";
    if (activeTab === "affiliate-applications")
      return "Custom Admin / Affiliate Applications";
    if (activeTab === "unaccepted-filings")
      return "Custom Admin / Unaccepted Filings";
    return "Custom Admin / Validate License";
  };

  return (
    <>
      <AdminNavBar />
      <main className="mainOneOne">
        <div className="content">
          <h2>{getPageTitle()}</h2>

          {activeTab === "validate-license" && <ValidateLicenseSection />}

          {activeTab === "logs" && <AdminLogsSection />}

          {activeTab === "registered-cpas" && <RegisteredCPAsSection />}

          {activeTab === "affiliate-applications" && <AffiliateApplicationsSection />}

          {activeTab === "unaccepted-filings" && <UnacceptedFilingsSection />}
        </div>
      </main>
    </>
  );
};

export default CustomAdminDashboard;
